import React from "react";
import { render } from "react-dom";

import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine-dark.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham-dark.css";

import { LicenseManager } from "@ag-grid-enterprise/core";

import App from "./App";
import "./index.scss";
import "./Grid.scss";
import LandingPage from "pages/LandingPage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DiagnosticRoutes } from "routes/DiagnosticRoutes";
import PolicyRoutes from "routes/PolicyRoutes";
import ProjectRoutes from "routes/ProjectRoutes";
import { InMemoryCache } from "@apollo/client";
import CustomLoader from "components/CustomLoader";
import { AADProvider } from "psg-react-components";
import { SnContext } from "utils/context";

LicenseManager.setLicenseKey(
    // todo: move to config
    "CompanyName=Accenture (Ashburn, VA),LicensedGroup=AMP,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-012087,ExpiryDate=11_February_2022_[v2]_MTY0NDUzNzYwMDAwMA==16c54cc1058a96f6c35900faa0834826"
);
type Config = {
    CLIENT_ID: string;
    TENANT_ID: string;
    REDIRECT_URI: string;
    SCOPE: string;
    GRAPH_ENDPOINT: string;
    SN_CONTEXT: string;
};

const { CLIENT_ID, TENANT_ID, REDIRECT_URI, SCOPE, GRAPH_ENDPOINT, SN_CONTEXT } = {
    ...((window as any).config as Config)
};
const root = document.getElementById("root");
if (root) {
    render(
        <AADProvider
            clientId={CLIENT_ID}
            redirectUri={REDIRECT_URI}
            scopes={[SCOPE]}
            tenantId={TENANT_ID}
            graphqlEndpoint={GRAPH_ENDPOINT}
            loadingView={<CustomLoader />}
            enableSubscriptions={true}
            customCache={
                new InMemoryCache({
                    addTypename: false
                })
            }
        >
            <SnContext.Provider value={SN_CONTEXT}>
                <BrowserRouter>
                    <div id="app" className="bp3-dark">
                        <Routes>
                            <Route path="/" element={<App />}>
                                <Route index element={<LandingPage />} />
                                <Route path="/project/*" element={<ProjectRoutes />} />
                                <Route path="/policies/*" element={<PolicyRoutes />} />
                                {DiagnosticRoutes}
                            </Route>
                        </Routes>
                    </div>
                </BrowserRouter>
            </SnContext.Provider>
        </AADProvider>,
        root
    );
}
